document.querySelectorAll('[data-modal-id]').forEach((modal) => {
  modal.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector(e.currentTarget.dataset.modalId).classList.toggle('active');
    document.querySelector('#nav-bar').style.zIndex = 9999;
  });
});

document.querySelectorAll('.modal-wrapper .overlay').forEach((overlay) => {
  overlay.addEventListener('click', (e) => {
    e.currentTarget.parentNode.classList.remove('active');
    document.querySelector('#nav-bar').style.zIndex = 9999;
  });
});
